export type AirbnbFlow = 'resolution_center' | 'reservation_alteration';

export function airbnbNoteFor(title: string, optionName?: string | null): string {
  const trimmedTitle = title.trim();
  if (optionName && optionName.trim().length > 0) {
    return `${trimmedTitle}: ${optionName.trim()}`;
  }
  return trimmedTitle;
}

export function isAirbnbHostname(rawUrl: string): boolean {
  try {
    const u = new URL(rawUrl);
    if (u.protocol !== 'https:') return false;
    const host = u.hostname.toLowerCase();
    return host === 'airbnb.com' || host === 'www.airbnb.com' || host.endsWith('.airbnb.com');
  } catch {
    return false;
  }
}
